<!--footer-->
<footer class="py-5" style="background: #061420">
  <div class="w-full max-w-6xl mx-auto px-3">
    <div class="row">
      <div
        class="col-sm-12 col-md-3 mr-auto d-inline-flex flex-row align-items-center"
      >
        <div>
          <img class="" src="./assets/img/logo-capital-divisas.svg" alt="" />

          <ul class="list-inline social social-lg">
            <!-- <li class="list-inline-item">
              <a href="" target="_blank"><i class="fa fa-linkedin-square"></i></a>
            </li> -->
            <li class="list-inline-item social-rounded">
              <a
                href="https://www.facebook.com/profile.php?id=100077675641436"
                target="_blank"
                ><i class="fa-brands fa-facebook"></i
              ></a>
            </li>
            <li class="list-inline-item">
              <a href="https://www.instagram.com/capitaldivisas" target="_blank"
                ><i class="fa-brands fa-instagram"></i
              ></a>
            </li>
            <li class="list-inline-item">
              <a href="https://twitter.com/capital_divisas" target="_blank"
                ><i class="fa-brands fa-x-twitter"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-12 col-md-3">
        <h5 class="text-color-primary text-capitalize">
          {{ 'FOOTER.LINKS_HEADING' | translate }}
        </h5>
        <ul class="list-unstyled-underline">
          <!-- <li><a href="#">Preguntas frecuentes</a></li> -->
          <li>
            <a [routerLink]="['aviso-de-privacidad']">{{
              'LANDING.PRIVACY_NOTICE.TITLE' | translate
            }}</a>
          </li>
          <li>
            <a [routerLink]="['terminos-y-condiciones']">{{
              'LANDING.TERMS.TITLE' | translate
            }}</a>
          </li>
          <!-- <li><a href="#">Política de cookies</a></li> -->
        </ul>
      </div>
      <div class="col-sm-12 col-md-3">
        <h5 class="text-color-primary text-capitalize">
          {{ 'FOOTER.CONTACT_HEADING' | translate }}
        </h5>
        <ul class="list-unstyled-underline">
          <li>
            <em data-feather="phone" width="14" height="14" class="mr-2"></em>
            <a href="tel:5511629830">551 162 9830</a>
          </li>
          <li>
            <em data-feather="mail" width="14" height="14" class="mr-2"></em>
            <a href="mailto:contacto@capitaldivisas.com" class="break-all"
              >contacto&#64;capitaldivisas.com</a
            >
          </li>
        </ul>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="aviso-privacidad text-justify">
          <h5>{{ 'FOOTER.LEGAL_TITLE' | translate }}</h5>

          <p>{{ 'FOOTER.LEGAL_P1' | translate }}</p>
          <p>{{ 'FOOTER.LEGAL_P2' | translate }}</p>
          <p>{{ 'FOOTER.LEGAL_P3' | translate }}</p>
          <p>{{ 'FOOTER.LEGAL_P4' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-muted text-center small-xl">
        {{ 'FOOTER.COPYRIGHT' | translate : { year: copyrightYear } }}
      </div>
    </div>
  </div>
</footer>
